package com.anjuros.website.templates.template6.components

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.selection.modules.Theme
import com.anjuros.website.templates.template6.modules.Template6Theme
import com.anjuros.website.templates.template6.modules.getColor
import com.anjuros.website.templates.template6.styles.Template6CallButton
import com.anjuros.website.templates.template6.styles.Template6SectionTitleStyle
import com.anjuros.website.templates.template6.util.ResKey
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun PrimaryButton(
    text: ResKey,
    path:String
) {

   PrimaryButton(
       text = LocalText(text),
       path = path
   )
}

@Composable
fun PrimaryButton(
    text: String,
    backgroundColor:CSSColorValue = Template6Theme.Primary.getColor(),
    path: String
) {

    Link(
        modifier = Modifier
            .textDecorationLine(TextDecorationLine.None),
      path = path,

    ) {
        Button(
            attrs = Template6CallButton.toModifier()
                .backgroundColor(backgroundColor)
                .color(Colors.White)
                .border(
                    width = 2.px,
                    style = LineStyle.Solid,
                    color = Template6Theme.Primary.getColor()
                )
                .boxShadow(
                    2.px, 2.px, 5.0.px, 1.0.px, color = Theme.DarkGrey.rgb, false
                )
                .padding(
                    leftRight = 34.px,
                    topBottom = 18.px
                )
                .borderRadius(10.px)
                .border(0.px)
                .fontSize(18.px)
                .fontWeight(FontWeight.Bold)
                .cursor(Cursor.Pointer)
                .toAttrs()
        ) {
            Text(text)
        }
    }
}

@Composable
fun OutlineButton(
    text: ResKey,
    path: String
) {
    Link(
        modifier = Modifier
            .textDecorationLine(TextDecorationLine.None),
        path = path,

        ) {
        Button(
            attrs = Template6CallButton.toModifier()
                .backgroundColor(Colors.Transparent)
                .color(Colors.White)
                .border(
                    width = 2.px,
                    style = LineStyle.Solid,
                    color = Colors.White
                )
                .boxShadow(
                    2.px, 2.px, 5.0.px, 1.0.px, color = Theme.DarkGrey.rgb, false
                )
                .padding(
                    leftRight = 34.px,
                    topBottom = 16.px
                )
                .borderRadius(10.px)
                .fontSize(18.px)
                .fontWeight(FontWeight.Bold)
                .cursor(Cursor.Pointer)
                .toAttrs()
        ) {
            Text(LocalText(text))
        }
    }
}


@Composable
fun SectionTitle(
    title: ResKey,
    subtitle: ResKey,
    horizontalAlignment: Alignment.Horizontal = Alignment.CenterHorizontally,
    textAlign: TextAlign = TextAlign.Center
) {

    Column(
        modifier = Modifier.fillMaxWidth(),
        horizontalAlignment = horizontalAlignment,
        verticalArrangement = Arrangement.Center
    ) {

        P(
            attrs = Modifier
                .fontSize(16.px)
                .fontWeight(FontWeight.Bold)
                .color(Template6Theme.DarkGrey.rgb)
                .letterSpacing(2.px)
                .margin(bottom = 16.px)
                .textTransform(TextTransform.Uppercase)
                .toAttrs()
        ) {
            Text(LocalText(subtitle))
        }

        P(
            attrs = Template6SectionTitleStyle.toModifier()
                .fontWeight(FontWeight.Bold)
                .textAlign(textAlign)
                .color(Template6Theme.Primary.getColor())
                .margin(0.px)
                .toAttrs()
        ) {
            Text(LocalText(title))
        }

    }

}